import { RootState } from 'editor/src/store/index';

import { Warning, WarningType } from '../types';

// GAPI-53417: hosts that set showWarningsOnlyAfterDesignRequest keep every warning quiet
// until the buyer hits Continue. The gang sheet's off-sheet warning is the exception:
// once a copy hangs over the edge the buyer has to move it while they are still
// arranging the sheet, so telling them at checkout time is too late.
export const alwaysVisibleWarningTypes = new Set<WarningType>([WarningType.OutsideSheet]);

const EMPTY_LIST: Warning[] = [];

// keyed on the list it came from, so every editor store in the bundle keeps its own
// entry: useSelector compares by reference, and rebuilding the array on each call would
// re-render the warnings UI on every unrelated store change
const filteredByList = new WeakMap<Warning[], Warning[]>();

const getVisibleWarnings = (state: RootState) => {
  const { list } = state.editorModules.warnings;
  if (!state.hostSettings.showWarningsOnlyAfterDesignRequest) {
    return list;
  }

  let filtered = filteredByList.get(list);
  if (!filtered) {
    const alwaysVisible = list.filter((warning) => alwaysVisibleWarningTypes.has(warning.type));
    filtered = alwaysVisible.length ? alwaysVisible : EMPTY_LIST;
    filteredByList.set(list, filtered);
  }

  return filtered;
};

export default getVisibleWarnings;
